const testimonials = [
  {
    name: "Robert K.",
    location: "Stuart, FL",
    rating: 5,
    text: "I'm a tournament angler here in Stuart and got invited to a last-minute sailfish tournament in the Bahamas with ten days' notice. Pulled my passport and it had expired two months ago during the off-season. Fast Passport Center had my renewal processed and back in my hands in three business days. I made the tournament, we placed second, and I didn't miss a day of fishing. Incredible service.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "Margaret T.",
    location: "Hutchinson Island, FL",
    rating: 5,
    text: "My husband and I are snowbirds from Pennsylvania who winter on Hutchinson Island. We booked a Caribbean cruise for February and discovered both our passports had expired while we were up north last summer. We were leaving in three weeks. Fast Passport Center handled both renewals simultaneously, kept us updated daily, and both passports arrived with a week to spare. We made our cruise and had the best vacation.",
    service: "Passport Renewal",
  },
  {
    name: "Dr. James L.",
    location: "Palm City, FL",
    rating: 5,
    text: "I am a cardiologist at Cleveland Clinic Martin Health and was invited to present at a conference in London with four weeks' notice. My passport was expiring the month after the conference, which violated the six-month rule for UK entry. Fast Passport Center expedited my renewal in five business days. I presented at the conference, and the process was seamless from start to finish.",
    service: "Expedited Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function StuartTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Stuart Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Stuart anglers, snowbirds, medical professionals, and families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}